import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()


export const lpaCashOfficeDetailsState = atom({
  key: 'lpaCashOfficeDetailsState',
  default: {
    LPAQuestions: [],
    responses: [],
    totalScore: []
  },
  effects_UNSTABLE: [persistAtom],
});